export default {
  title: 'Recompense',
  guest: {
    eyebrow: 'Recompense',
    headline: 'Fiecare comandă îți aduce <highlight>recompense</highlight>',
    subheading_one: 'Câștigă {{count}} punct pentru fiecare {{amount}} cheltuit.',
    subheading_few: 'Câștigă {{count}} puncte pentru fiecare {{amount}} cheltuit.',
    subheading_other: 'Câștigă {{count}} puncte pentru fiecare {{amount}} cheltuit.',
    cta: 'Înregistrează-te & începe să câștigi',
    already_member: 'Ești deja membru?',
    sign_in: 'Autentifică-te',
    redeemable_heading: 'Punctele tale = mâncare gratuită',
    redeemable_eyebrow: '🎁 Recompense pe care le deblochezi',
  },
  member: {
    balance_label: 'Soldul tău',
    balance_suffix: 'puncte · valoare <highlight>{{amount}}</highlight>',
    next_reward: 'Următoarea recompensă la <highlight>{{points}} pts</highlight>',
    redeem_hint: '✓ Poți valorifica până la {{points}} pts ({{amount}}) la următoarea comandă',
    expiration_zero: '⏳ {{points}} pts expiră astăzi',
    expiration_one: '⏳ {{points}} pts expiră în 1 zi',
    expiration_few: '⏳ {{points}} puncte expiră în {{count}} zile',
    expiration_other: '⏳ {{points}} pts expiră în {{count}} zile',
    pts_lifetime: 'Durată de viață pts',
    saved_lifetime: 'Economisit total',
    cta: 'Comandă acum',
    redeemable_heading: 'Ce poți valorifica',
    redeemable_eyebrow: 'Ai {{points}} pts ({{amount}})',
    redeemable_description:
      'Până la {{maxPoints}} pts ({{maxAmount}}) per comandă. Articolele sub {{maxAmount}} sunt complet gratuite.',
  },
  items: {
    free: 'GRATUIT',
    save: 'Economisești {{amount}}',
  },
  history: {
    eyebrow: 'Istoric',
    title: 'Activitate recentă',
    load_more: 'Încarcă mai mult',
    sources: {
      welcome_bonus: 'Bonus de bun venit',
      google_review_reward: 'Recompensă recenzie Google',
      reward_loyalty_program_conversion: 'Conversie program de loialitate',
      cashback: 'Cashback acumulat',
      refund: 'Comandă rambursată',
      cashback_usage: 'Puncte utilizate',
      cashback_usage_refund: 'Răscumpărare rambursată',
      expired_points_void: 'Puncte expirate',
      mobile_app_signup_bonus: 'Bonus înregistrare aplicație mobilă',
    },
    detail_with_order: 'Comanda #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Simplu și automat',
    eyebrow_member: 'Reminder rapid',
    title: 'Cum funcționează',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Înregistrare gratuită',
        desc: 'Creează un cont în 30 de secunde.',
      },
      order: {
        emoji: '🍔',
        title: 'Comandă și câștigă',
        desc_one: '1 pt per {{amount}} — urmărit automat.',
        desc_few: '{{count}} puncte pentru fiecare {{amount}} — urmărite automat.',
        desc_other: '{{count}} pts per {{amount}} — urmărit automat.',
      },
      build: {
        emoji: '⭐',
        title: 'Acumulează puncte',
        desc: 'Folosește de la {{minPoints}} pts. Valabil {{lifetime}} zile.',
      },
      save: {
        emoji: '🎁',
        title: 'Economisești la finalizare',
        desc: 'Până la {{maxAmount}} reducere — aplicat instant.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Repetă și economisești',
        desc: 'Fiecare comandă îți crește soldul.',
      },
    },
  },
  faq: {
    eyebrow: 'Întrebări?',
    title: 'Întrebări frecvente',
    items: {
      earn: {
        q: 'Cum acumulez puncte?',
        a_one:
          'Câștigi 1 punct pentru fiecare {{amount}} cheltuit. Punctele sunt adăugate automat în contul tău după fiecare comandă — fără scanare sau coduri necesare.',
        a_few:
          'Primești {{count}} puncte pentru fiecare {{amount}} cheltuit. Punctele se adaugă automat în contul tău după fiecare comandă — fără scanări sau coduri.',
        a_other:
          'Câștigi {{count}} puncte pentru fiecare {{amount}} cheltuit. Punctele sunt adăugate automat în contul tău după fiecare comandă — fără scanare sau coduri necesare.',
      },
      redeem: {
        q: 'Când pot începe să folosesc punctele?',
        a: 'Poți începe să folosești punctele odată ce atingi {{minPoints}} puncte. Folosește-le la finalizarea comenzii pentru a reduce totalul.',
      },
      max: {
        q: 'Cât pot economisi per comandă?',
        a: 'Poți folosi până la {{maxPoints}} puncte ({{maxAmount}}) per comandă. Aceasta este reducerea maximă pe care o poți aplica la o singură comandă.',
      },
      validity: {
        q: 'Cât timp sunt valabile punctele?',
        a: 'Punctele sunt valabile {{lifetime}} zile de la data acumulării. Folosește-le înainte să expire!',
      },
    },
  },
};
